export default __webpack_public_path__ + "static/media/ans1.5fdfa60f.png";